import { getMovies, getPodborka, getPodborkaInner } from "../Api";
export default {
    state: {
        interesting: null,
        viewed: null,
        selection: [],
        visibleSelections: []
    },
    actions: {
        async fetchInteresting({ commit }, payload) {
            const { isLoggedIn, limit, favorited_only, lang } = payload;
            try {
                const respons = await getMovies(isLoggedIn, {
                    limit,
                    favorited_only,
                    lang
                });
                commit("SET_INTERESTING", respons);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchViewed({ commit }, payload) {
            const { isLoggedIn, limit, is_viewing, lang } = payload;
            try {
                const respons = await getMovies(isLoggedIn, {
                    limit,
                    is_viewing,
                    lang
                });
                commit("SET_VIEWED", respons);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchSelection({ commit }) {
            try {
                const respons = await getPodborka();
                commit("SET_SELECTION", respons);
            } catch (error) {
                console.error(error);
            }
        }
    },
    mutations: {
        SET_INTERESTING(state, content) {
            state.interesting = content;
        },
        SET_VIEWED(state, content) {
            state.viewed = content;
        },
        SET_SELECTION(state, content) {
            state.selection = content;
        },
        SET_VISIBLE_SELECTIONS(state, selection) {
            state.visibleSelections.push(selection);
        }
    },
    getters: {
        getInterestingVideos(state) {
            return state.interesting;
        },
        getViewedVideos(state) {
            return state.viewed;
        },
        getSelection(state) {
            return state.selection;
        },
        getVisibleSelections(state) {
            return state.visibleSelections;
        }
    }
};
